import * as React from "react";
import { EnvelopeIcon } from "../../../../assets/images/svg/ProductLogoCollection";
interface IHeaderProps {
    title: string;
}
const Header: React.FC<IHeaderProps> = props => {
    return (
        <header>
            <EnvelopeIcon height={50} width={300} />
            <h2>{props.title}</h2>
        </header>
    );
};

export default Header;
